import React from 'react';
import Select, { components, createFilter } from 'react-select';

const { Option, SingleValue } = components;

const IconOption = (props) => (
  <Option {...props}>
    {
      props.data && props.data.icon && props.data.icon !== "" &&
      <img
        src={require('./flags/' + props.data.icon)}
        style={{ width: "30px", marginRight: '4px'}}
        alt={props.data.label}
      />
    }
    {props.data.label}
  </Option>
);

const ValueOption = (props) => (
  <SingleValue {...props}>
    {
      props.data && props.data.icon && props.data.icon !== "" &&
      <img
        src={require('./flags/' + props.data.icon)}
        style={{ width: "30px", marginRight: '4px'}}
        alt={props.data.label} 
      />
    }
    {props.data.label}
  </SingleValue>
);

const SelectCountry = ({
  onChange,
  value,
  isSearchable,
  options,
  placeholder = ""
}) => {

  const filterConfig = {
    ignoreCase: true,
    matchFrom: 'start',
    ignoreAccents: true
  };

  return (
    <Select
      value={value}
      options={options}
      onChange={onChange}
      placeholder={placeholder}
      isSearchable={isSearchable}
      isClearable={false}
      filterOption={createFilter(filterConfig)}
      components={{ Option: IconOption, SingleValue : ValueOption }}
    />
  )
}

export default SelectCountry;